import React from 'react';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ProventosRow from './ProventosRow';

import { ComposedChart, Bar, Area, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';

class Proventos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ativo: {},
            proventos: [],
            histProventos: [],
            provento: {
                tipo: 'DIV',
                data: moment(),
                valor: '',
                ativo_id: '',
            },
            listaTipos: [
                {id: 'DIV', nome: 'Dividendos'},
                {id: 'JCP', nome: 'Juros sobre Capital'},
                {id: 'ALUG', nome: 'Aluguel'},
                {id: 'CUPOM', nome: 'Cupom'},
                {id: 'REND', nome: 'Rendimentos'},
            ],
            somatoria: {
                div: 0.0, jcp: 0.0, alug: 0.0, cup: 0.0, rend: 0.0, total: 0.0
            },
            
        };
    }

    componentDidMount = async () => {
        try { 
            //Obtendo o id do ativo
            if(this.props.match.params.id) {
                const res = await axios.get(`${ambiente.dev.server}/ativos/${this.props.match.params.id}`);
                let tipoSugerido = 'DIV';
                if(res.data.tipo === 'FII') tipoSugerido = 'ALUG';
                const provento = Object.assign({}, this.state.provento, {ativo_id: res.data.id, tipo: tipoSugerido});
                this.setState({ ativo: res.data, provento });

                this.atualizarProventos();
            }
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    atualizarProventos = async () => {
        const resProv = await axios.get(`${ambiente.dev.server}/proventos?ativo=${this.props.match.params.id}`);
        this.setState({ proventos: resProv.data });
        const somatoria = {div: 0.0, jcp: 0.0, alug: 0.0, cup: 0.0, rend: 0.0, total: 0.0};
        resProv.data.forEach(item => {
            switch(item.tipo) {
                case 'DIV': somatoria.div += parseFloat(item.valor); break;
                case 'JCP': somatoria.jcp += parseFloat(item.valor); break;
                case 'ALUG': somatoria.alug += parseFloat(item.valor); break;
                case 'REND': somatoria.rend += parseFloat(item.valor); break;
                case 'CUPOM': somatoria.cup += parseFloat(item.valor); break;
                default: this.props.exibirMensagem('err', `Tipo '${item.tipo} desconhecido'`); break;
            }
        });
        somatoria.total = somatoria.div + somatoria.jcp + somatoria.alug + somatoria.rend + somatoria.cup;
        this.setState({ somatoria });

        const res = await axios.get(`${ambiente.dev.server}/relatorios/historicoProventosPorAtivo?ativo_id=${this.props.match.params.id}`);
        this.setState({ histProventos: res.data });
    }

    handleChangeProvAtt(nome, valor) {
        const provento = Object.assign({}, this.state.provento);
        provento[nome] = valor;
        this.setState({ provento });
    }

    handleSave = async () => {
        try {
            await axios.post(`${ambiente.dev.server}/proventos`, this.state.provento);
            this.props.exibirMensagem('yay', `Provento inserido com sucesso!`);
            this.atualizarProventos();
          } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
          }
    }

    handleDelete = async (id) => {
        try { 
            await axios.delete(`${ambiente.dev.server}/proventos/${id}`);
            this.props.exibirMensagem('yay', `Provento removido com sucesso!`);
            this.atualizarProventos();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        const provento = this.state.provento;
        return (
            <div>
                <div className="row">
                    <div className="form-group col-6 col-md-4">
                        <h3>{this.state.ativo.nome}</h3>
                    </div>
                    <div className="form-group col-6 col-md-4" data-toggle="buttons">
                        <select className="form-control" autoFocus value={provento.tipo} onChange={evt => this.handleChangeProvAtt('tipo', evt.target.value)}>
                            {this.state.listaTipos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col col-md-4">
                        <input type="date" className="form-control" value={provento.data.format('YYYY-MM-DD')} 
                            onChange={evt => this.handleChangeProvAtt('data', moment(evt.target.value, 'YYYY-MM-DD'))}/>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col">
                        <input type="number" step="0.01" className="form-control" value={provento.valor} placeholder="Valor"
                            onChange={evt => this.handleChangeProvAtt('valor', evt.target.value)} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Salvar
                </button>
                <div className="list-group">
                    {this.state.proventos &&
                        this.state.proventos.map(item => <ProventosRow key={item.id} {...item} handleDelete={this.handleDelete} /> )}
                </div>
                <li className="list-group-item list-group-item-action flex-column align-items-start"> 
                    <div className="d-flex w-100 justify-content-between">
                        <small>DIV: {this.state.somatoria.div.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        <small>JCP: {this.state.somatoria.jcp.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        <small>ALUG: {this.state.somatoria.alug.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        <small>Total: {this.state.somatoria.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                    </div>
                </li>
                <div>
                    <ComposedChart width={1000} height={300} data={this.state.histProventos}>
                        <XAxis dataKey="data" />
                        <YAxis yAxisId="left"/>
                        <YAxis yAxisId="right" orientation="right" />

                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Area yAxisId="left" dataKey="ultimaCotacao" fill="#CCCCCC" />
                        <Bar yAxisId="left" dataKey="proventos" fill="#4286f4" />
                        <Line type="monotone" yAxisId="right" dataKey="razao" stroke="#ff7300" />
                        <Tooltip cursor={false}/>
                    </ComposedChart>
                </div>
            </div>
        );
    }
}

Proventos.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Proventos);
  


// WEBPACK FOOTER //
// ./src/components/proventos/Proventos.js